import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

const LookUpNavigation = ({ onLookupClick, isShowing }) => (
  <div className="lookup-nav-container" onClick={onLookupClick}>
    <div className="lookup-text text-primary-bold">
      <Button
        fluid
        size="medium"
        primary
        compact
        icon={isShowing ? 'close' : 'search'}
      />
    </div>
  </div>
);

LookUpNavigation.propTypes = {
  onLookupClick: PropTypes.func.isRequired,
  isShowing: PropTypes.bool.isRequired,
};

export default LookUpNavigation;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/component/LookUpNavigation.js